export default "__VITE_ASSET__bb3966f3__"